
// Legacy export for backward compatibility - will use locale-aware formatting
export const formatNumber = (num: number) => {
  return num.toLocaleString('en-US', { maximumFractionDigits: 2 });
};

// Import the getPricingConstants function from the new structure
import { getPricingConstants } from './media-owners';

// Updated to accept mediaOwner parameter
export const calculateDiscount = (deviceCount: number, mediaOwner = 'TableAds') => {
  const { 
    discountScreensThreshold, 
    baseDiscountRate, 
    maxDiscountRate 
  } = getPricingConstants(mediaOwner);
  
  const discountMultiplier = Math.floor(deviceCount / discountScreensThreshold);
  const calculatedDiscount = baseDiscountRate * discountMultiplier;
  return Math.min(calculatedDiscount, maxDiscountRate);
};

export const generateDailyData = (total: number, duration: number, metric: string) => {
  const data = [];
  const perDay = total / duration;
  let accumulatedValue = 0;

  for (let day = 0; day <= duration; day++) {
    if (day === duration) {
      accumulatedValue = total;
    } else {
      const remainingDays = duration - day;
      const maxAllowedIncrement = (total - accumulatedValue) / remainingDays;
      const baseIncrement = Math.min(perDay, maxAllowedIncrement);
      const randomFactor = 0.95 + Math.random() * 0.1;
      const dailyIncrement = Math.min(baseIncrement * randomFactor, maxAllowedIncrement);
      
      accumulatedValue += dailyIncrement;
    }

    data.push({
      day,
      [metric]: Math.round(accumulatedValue)
    });
  }
  return data;
};
